











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.ProductionSite.SetBinValuesCommand')
    
    export class SetBinValuesCommand {
        constructor( binId: number, bins: number[], vss: number[], vsi: number[], showGraph: boolean[] ) {
            
                this.binId = binId;
            
                this.bins = bins;
            
                this.vss = vss;
            
                this.vsi = vsi;
            
                this.showGraph = showGraph;
            
        }

        
            public binId: number;
        
            public bins: number[];
        
            public vss: number[];
        
            public vsi: number[];
        
            public showGraph: boolean[];
        
    }

    export interface ISetBinValuesCommand {
        
            binId: number;
        
            bins: number[];
        
            vss: number[];
        
            vsi: number[];
        
            showGraph: boolean[];
        
    }

    export async function setBinValues( command: SetBinValuesCommand ): Promise<CommandResult<void>>
    export async function setBinValues( { binId, bins, vss, vsi, showGraph }: ISetBinValuesCommand ): Promise<CommandResult<void>>
    export async function setBinValues( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof SetBinValuesCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new SetBinValuesCommand( model['binId'], model['bins'], model['vss'], model['vsi'], model['showGraph'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace SetBinValuesCommand.ExtraneousTypes {
        

        
    }

